import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './H2.scss'

function H2({ children, className }) {
  const componentClass = cx(style.h2, { [className]: className })
  return <h2 className={componentClass}>{children}</h2>
}

H2.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default H2



// WEBPACK FOOTER //
// ./src/components/Common/H2.js